// @ts-nocheck
import { togaApiRequest } from "../../../api/toga";
import { getQueryParams } from "../../../utils/getQueryParams";
import * as Sentry from "@sentry/react";
interface BaseOptions {
	transactionId?: string;
	sort?: any;
	[key: string]: any;
}

type SimpleField = string;

type ComplexField = {
	[key: string]: string[] | { [key: string]: string[] } | undefined;
	location?: string[]; // Add location and shipToAddress as optional
	shipToAddress?: string[];
};

type LocationAndShipToField = {
	location: string[];
	shipToAddress: string[];
};

type UnifiedField = SimpleField | ComplexField | LocationAndShipToField;

interface OptionsType extends BaseOptions {
	fields?: UnifiedField[];
}

interface ExtendedOptionsType extends OptionsType {
	where?: any;
	join?: any;
	ojoin?: any;
	recordsPerPage?: number;
	page?: number;
}

interface GetInventoryOptions extends ExtendedOptionsType {}

//getting all Inventory Items with units
export async function getInventoryItems(options: GetInventoryOptions = {}) {
	const unitRecordsPerItem = 15;
	const defaultOptions = {
		recordsPerPage: 10,
		page: 1,
		sort: ["description"],
	};

	const requestOptions = {
		...defaultOptions,
		...options,
		fields: [
			"uuid",
			"description",
			"upcCode",
			"skuNumber",
			"_qtyTotal",
			{
				manufacturer: ["name"],
			},
		],
	};
	const response = await togaApiRequest(
		"GET",
		"/items",
		null,
		requestOptions
	);

	if (response.isSuccess) {
		let items = response.data.items;

		let baseUnitOptions: ExtendedOptionsType = {
			ojoin: [
				{
					ItemReceiptItemUnits: {
						"ItemReceiptItemUnits.unitId": "Units.id",
					},
				},
				{
					ItemReceiptItems: {
						"ItemReceiptItems.id":
							"ItemReceiptItemUnits.itemReceiptItemId",
					},
				},
				{
					ItemReceipts: {
						"ItemReceipts.id": "ItemReceiptItems.itemReceiptId",
					},
				},
				{
					PurchaseOrderItems: {
						"PurchaseOrderItems.id":
							"ItemReceiptItems.purchaseOrderItemId",
					},
				},
				{
					PurchaseOrders: {
						"PurchaseOrders.id":
							"PurchaseOrderItems.purchaseOrderId",
					},
				},
				{
					SalesOrderItems: {
						"SalesOrderItems.id":
							"PurchaseOrderItems.createdFromSalesOrderItemId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "SalesOrderItems.salesOrderId",
					},
				},
			],
		};

		for (const i in items) {
			const item = items[i];

			let unitsResponse;
			if (item.isSerialized) {
				// get/populate the serialized units
				const unitOptions: ExtendedOptionsType = {
					...baseUnitOptions,
					fields: [
						"uuid",
						"serialNumber",
						{
							location: ["uuid"],
							unitDisposition: ["name"],
							SalesOrders: ["customerPurchaseOrder"],
							SalesOrderItems: ["price"],
							PurchaseOrders: ["dateOrder"],
						},
					],
				};
				unitsResponse = await togaApiRequest(
					"GET",
					"/items/" + item.uuid + "/units",

					unitOptions
				);
			} else {
				// get/populate the non-serialized units

				const unitOptions: ExtendedOptionsType = {
					...baseUnitOptions,
					fields: [
						"_count",
						{
							location: ["uuid"],
							unitDisposition: ["name"],
							SalesOrders: ["customerPurchaseOrder"],
							SalesOrderItems: ["price"],
							PurchaseOrders: ["dateOrder"],
						},
					],
				};
				unitsResponse = await togaApiRequest(
					"GET",
					"/items/" + item.uuid + "/units",
					null,
					unitOptions
				);

			}
			if (unitsResponse.isSuccess) {
				items[i].units = unitsResponse.data.units;
			}
		}

		return {
			meta: response.meta,
			items: response.data.items,
		};
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

//	Getting Selected Inventory Item with all Units (View All)
export async function getSelectedInventoryItems(uuid: string) {
	const unitsField: Field = {
		contact: ["firstName", "lastName"],
		location: ["name"],
		unitDisposition: ["name"],
	};

	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"description",
			"upcCode",
			"skuNumber",
			"isSerialized",
			"_qtyTotal",
			{
				manufacturer: ["name"],
			},
		],
	};

	const response = await togaApiRequest(
		"GET",
		"/items/" + uuid,
		null,
		options
	);

	if (response.isSuccess) {
		let item = response.data.items;

		let baseUnitOptions: ExtendedOptionsType = {
			ojoin: [
				{
					ItemReceiptItemUnits: {
						"ItemReceiptItemUnits.unitId": "Units.id",
					},
				},
				{
					ItemReceiptItems: {
						"ItemReceiptItems.id":
							"ItemReceiptItemUnits.itemReceiptItemId",
					},
				},
				{
					ItemReceipts: {
						"ItemReceipts.id": "ItemReceiptItems.itemReceiptId",
					},
				},
				{
					PurchaseOrderItems: {
						"PurchaseOrderItems.id":
							"ItemReceiptItems.purchaseOrderItemId",
					},
				},
				{
					PurchaseOrders: {
						"PurchaseOrders.id":
							"PurchaseOrderItems.purchaseOrderId",
					},
				},
				{
					SalesOrderItems: {
						"SalesOrderItems.id":
							"PurchaseOrderItems.createdFromSalesOrderItemId",
					},
				},
				{
					SalesOrders: {
						"SalesOrders.id": "SalesOrderItems.salesOrderId",
					},
				},
			],
		};

		let unitsResponse;
		if (item.isSerialized) {
			// get/populate the serialized units
			const unitOptions: ExtendedOptionsType = {
				...baseUnitOptions,
				fields: [
					"uuid",
					"serialNumber",
					{
						location: ["uuid"],
						unitDisposition: ["name"],
						SalesOrders: ["customerPurchaseOrder"],
						SalesOrderItems: ["price"],
						PurchaseOrders: ["dateOrder"],
					},
				],
			};
			unitsResponse = await togaApiRequest(
				"GET",
				"/items/" + uuid + "/units",
				null,
				unitOptions
			);
		} else {
			// get/populate the non-serialized units
			const unitOptions: ExtendedOptionsType = {
				...baseUnitOptions,
				fields: [
					"_count",
					{
						location: ["uuid"],
						unitDisposition: ["name"],
						SalesOrders: ["customerPurchaseOrder"],
						SalesOrderItems: ["price"],
						PurchaseOrders: ["dateOrder"],
					},
				],
			};
			unitsResponse = await togaApiRequest(
				"GET",
				"/items/" + uuid + "/units",
				null,
				unitOptions
			);
		}

		if (unitsResponse.isSuccess) {
			response.data.items.units = unitsResponse.data.units;
		}

		return {
			meta: response.meta,
			items: response.data.items,
		};
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

// getting Inventory Unit Details (View Details)
export async function getInventoryUnitDetails(uuid: string) {
	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"assetTag",
			"serialNumber",
			"dateWarrantyExpiration",
			"dateExpectedRetirement",
			{
				contact: ["firstName", "lastName"],
				location: ["name"],
				unitDisposition: ["name", "isAvailable"],
				item: [
					"uuid",
					"skuNumber",
					"description",
					"partNumber",
					"upcCode",
					"modelNumber",
					{
						manufacturer: ["name"] as unknown as Field,
					},
				] as Field[],
			},
		] as Field[],
	};

	const response = await togaApiRequest(
		"GET",
		"/units/" + uuid,
		null,
		options
	);

	if (response.isSuccess) {
		const optionsNote: ExtendedOptionsType = {
			fields: [
				"uuid",
				"note",
				"dtCreated",
				{
					contact: ["firstName", "lastName"],
				},
			],
		};

		//Getting Unit Notes
		const unitNoteResponse = await togaApiRequest(
			"GET",
			"/units/" + uuid + "/unit-notes",
			null,
			optionsNote
		);

		const optionsSalesOrder: ExtendedOptionsType = {
			fields: ["uuid", "dateOrder", "number", "customerPurchaseOrder"],
			join: [
				{
					SalesOrderItems: {
						"SalesOrders.id": "SalesOrderItems.salesOrderId",
					},
					ItemFulfillmentItems: {
						"ItemFulfillmentItems.salesOrderItemId":
							"SalesOrderItems.id",
					},
					ItemFulfillmentItemUnits: {
						"ItemFulfillmentItemUnits.itemFulfillmentItemId":
							"ItemFulfillmentItems.id",
					},
					Units: { "Units.id": "ItemFulfillmentItemUnits.unitId" },
				},
			],
			where: {
				and: [{ "Units.uuid": { "=": uuid } }],
			},
		};

		const SalesOrderResponse = await togaApiRequest(
			"GET",
			"/sales-orders",
			null,
			optionsSalesOrder
		);

		const combinedData = {
			response: response.data.units,
			salesOrders: SalesOrderResponse.data.salesOrders,
			unitNotes: unitNoteResponse.data.unitNotes,
		};

		return combinedData;
	} else {
		console.log(":(");
	}
}

//getting Inventory Items and Units for BOA
export async function getInventoryDetailsBOA(
	options: GetInventoryOptions = {}
) {
	const unitRecordsPerItem = 5;
	const defaultOptions = {
		recordsPerPage: 10,
		page: 1,
	};

	const requestOptions = {
		...defaultOptions,
		...options,
		fields: [
			"uuid",
			"description",
			"modelNumber",
			"_qtyTotal",
			{
				manufacturer: ["name"],
			},
			{
				assetType: ["name"],
			},
		],
	};
	const response = await togaApiRequest(
		"GET",
		"/items",
		null,
		requestOptions
	);

	if (response.isSuccess) {
		let items = response.data.items;

		const unitDefaultOptions = {
			recordsPerPage: unitRecordsPerItem,
			page: 1,
		};

		for (const i in items) {
			const item = items[i];

			// get current query params
			const queryParams = getQueryParams();
			let unitsResponse;
			// get/populate the serialized units

			let unitOptions = {
				...unitDefaultOptions,
				fields: [
					"uuid",
					"serialNumber",
					{
						contact: ["name"],
						location: ["name"],
						unitDisposition: ["name"],
						unitStage: ["name"],
					},
				],
			};

			if (queryParams.sort) {
				// overriding sort specified
				const sortValue = queryParams.sort;
				const sortDirection = sortValue.startsWith("-")
					? sortValue.charAt(0)
					: "";
				const sortColumnSlug = sortValue.substring(1);
				unitOptions.sort = unitOptions.sort || [];

				if (sortColumnSlug == "Serial Number") {
					unitOptions.sort.push(sortDirection + "serialNumber");
				}
				// @ts-ignore
			}

			if (queryParams["Serial Number"]) {
				unitOptions.where = unitOptions.where || [];
				unitOptions.where.and = [];
				unitOptions.where.and.push({
					["serialNumber"]: {
						contains: queryParams["Serial Number"],
					},
				});
			}

			unitsResponse = await togaApiRequest(
				"GET",
				"/items/" + item.uuid + "/units",
				null,
				unitOptions
			);

			if (unitsResponse.isSuccess) {
				items[i].units = unitsResponse.data.units;
			}
		}

		return {
			meta: response.meta,
			items: items,
		};
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

// getting Inventory Unit Details (View Details)
export async function getInventoryUnitDetailsBOA(uuid: string) {
	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"serialNumber",
			"c_dateCheckIn",
			"c_dateDisposition",
			"c_rmaNumber",
			"dateExpectedRetirement",
			{
				unitStage: ["name"],
				receivingTrackingNumber: ["number"],
				returningTrackingNumber: ["number"],
				location: [
					"c_mailingCode",
					"_addressLine1",
					"_addressLine2",
					"_addressCity",
					"_addressZip",
					"_addressState",
				],
				unitDisposition: ["name"],
				item: [
					"uuid",
					"description",
					"modelNumber",
					{
						manufacturer: ["name"],
						assetType: ["name"],
					},
				] as Field[],
			},
		] as Field[],
	};

	const response = await togaApiRequest(
		"GET",
		"/units/" + uuid,
		null,
		options
	);

	if (response.isSuccess) {
		const optionsNote: ExtendedOptionsType = {
			fields: [
				"uuid",
				"note",
				"unitNoteType.name",
				{
					contact: ["firstName", "lastName"],
					// unit: ["uuid"],
				},
			],
		};

		//Getting Unit Notes
		const unitNoteResponse = await togaApiRequest(
			"GET",
			"/units/" + uuid + "/unit-notes",
			null,
			optionsNote
		);

		var unitsData = response.data.units;
		unitsData.unitCondition = unitNoteResponse.data.unitNotes[0].note;
		unitsData.unitConditionNotes = unitNoteResponse.data.unitNotes[1].note;
		const combinedData = {
			unitsData: response.data.units,
		};

		return combinedData;
	} else {
		console.log(":(");
	}
}

//getting Inventory Items and all Units
export async function getSelectedInventoryItemsBOA(uuid: string) {
	const defaultOptions = {
		recordsPerPage: 100,
		page: 1,
	};

	const requestOptions = {
		...defaultOptions,
		fields: [
			"uuid",
			"description",
			"modelNumber",
			"_qtyTotal",
			{
				manufacturer: ["name"],
			},
			{
				assetType: ["name"],
			},
		],
	};

	const response = await togaApiRequest(
		"GET",
		"/items/" + uuid,
		null,
		requestOptions
	);

	if (response.isSuccess) {
		let items = response.data.items;
		const item = items;

		let unitsResponse;
		// get/populate the serialized units
		const unitOptions = {
			...defaultOptions,
			fields: [
				"uuid",
				"serialNumber",
				{
					contact: ["name"],
					location: ["name"],
					unitDisposition: ["name"],
					unitStage: ["name"],
				},
			],
		};

		// get current query params
		const queryParams = getQueryParams();

		if (queryParams.sort) {
			// overriding sort specified
			const sortValue = queryParams.sort;
			const sortDirection = sortValue.startsWith("-")
				? sortValue.charAt(0)
				: "";
			const sortColumnSlug = sortValue.substring(1);
			unitOptions.sort = unitOptions.sort || [];

			if (sortColumnSlug == "Serial Number") {
				unitOptions.sort.push(sortDirection + "serialNumber");
			}
		}

		if (queryParams["Serial Number"]) {
			unitOptions.where = unitOptions.where || [];
			unitOptions.where.and = [];
			unitOptions.where.and.push({
				["serialNumber"]: {
					contains: queryParams["Serial Number"],
				},
			});
		}

		unitsResponse = await togaApiRequest(
			"GET",
			"/items/" + item.uuid + "/units",
			null,
			unitOptions
		);

		if (unitsResponse.isSuccess) {
			items.units = unitsResponse.data.units;
		}
		return {
			meta: response.meta,
			items: items,
		};
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

//Get item details for the Items Modal
export async function getItemDetails(uuid: string) {
	// const requestOptions = {
	// 	fields: [
	// 		"uuid",
	// 		"description",
	// 		"modelNumber",
	// 		"_qtyTotal",
	// 		{
	// 			manufacturer: ["name"],
	// 		},
	// 		{
	// 			assetType: ["name"],
	// 		},
	// 	],
	// };

	const response = await togaApiRequest("GET", "/items/" + uuid, null, []);

	if (response.isSuccess) {
		let items = response.data.items;
		const item = items;
		return item;
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

//Getting Group By Items Modal Data
export async function getTableViewGroups() {
	const defaultOptions = {
		recordsPerPage: 100,
		page: 1,
	};

	const requestOptions = {
		...defaultOptions,
		// fields: [
		// ],
	};

	const response = await togaApiRequest(
		"GET",
		"/pages-default-table-view-groups",
		null,
		requestOptions
	);

	if (response.isSuccess) {
		let tableViewGroupData = response.data.tableViewGroups;
		return tableViewGroupData;
	} else {
		Sentry.captureMessage("items", {
			level: "warning",
			tags: {
				errorType: "API",
			},
			extra: response,
		});
 	}
}

// fetch all the data for that “Unit” modal
// api/InventoryApi.ts
export async function getUnitDetails(unitUuid: string) {
	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"assetTag",
			"serialNumber",
			"name",
			"isSellable",
			"location.name",
			"location.locationType.name",
			"unitDisposition.name",
			"unitStage.name",
			"unitCondition.name",
			"contact._name",
			"contact.primaryContactAddress.address._singleLineFullAddress",
			"item.uuid",
			"item.skuNumber",
			"item.description",
			"item.partNumber",
			"item.upcCode",
			"item.modelNumber",
			"item.manufacturer.name",
			"item.assetType.name",
			"item.itemType.name",
			"item.itemDepartment.name",
			"item.itemCategory.name",
			"item.itemClass.name",
			"item.title",
			"item.isActive",
			"item.itemImages.highImage.sourceUrl",
			"item._thumbnailImageUrl",
		],
	};

	// await into `resp` and pass the correct `options` variable
	const resp = await togaApiRequest(
		"GET",
		`/units/${unitUuid}`,
		null,
		options
	);

	if (resp?.isSuccess) {
		return resp.data.units;
	} else {
		Sentry.captureMessage("getUnitDetails", {
			level: "warning",
			tags: { errorType: "API" },
			extra: resp,
		});
		console.error("Failed to load units", resp);
		return [];
	}
}

// fetch all the data for that “Sales” modal
export async function getSalesByUnit(unitUuid: string) {
	const options: ExtendedOptionsType = {
		page: 1,
		recordsPerPage: 1,
		sort: ["-dateOrder"],
		fields: [
			"uuid",
			"dateOrder",
			"number",
			"SalesOrderItems.price",
			"Customers.name",
			"Invoices.dateInvoice",
			"Invoices.status",
			"Invoices.number",
			"PurchaseOrders.number",
			"TrackingNumbers.number",
			"TrackingNumbers.status", //ShippingStatus
			"ItemFulfillments.dateItemFulfillment", //Scanned On
			"ItemFulfillments.number", //Fulfillment Number
			"ShippingMethods.name", //Method
			"ShippingCarriers.name", //Carrier
			"Addresses._singleLineFullAddress", //Ship To Address
			"Users._name",
		],
		ojoin: [
			{
				ItemFulfillments: {
					"ItemFulfillments.salesOrderId": "SalesOrders.id",
				},
			},
			{
				Locations: {
					"ItemFulfillments.locationId": "Locations.id",
				},
			},
			{
				Locations_Addresses: {
					"Locations.primaryLocationAddressId":
						"Locations_Addresses.id",
				},
			},
			{
				Addresses: {
					"Locations_Addresses.addressId": "Addresses.id",
				},
			},
			{
				ItemFulfillmentItems: {
					"ItemFulfillmentItems.itemFulfillmentId":
						"ItemFulfillments.id",
				},
			},
			{
				ItemFulfillmentItemUnits: {
					"ItemFulfillmentItemUnits.itemFulfillmentItemId":
						"ItemFulfillmentItems.id",
				},
			},
			{
				TrackingNumbers: {
					"TrackingNumbers.id":
						"ItemFulfillmentItemUnits.trackingNumberId",
				},
			},
			{
				ShippingCarriers: {
					"ShippingCarriers.id": "TrackingNumbers.shippingCarrierId",
				},
			},
			{
				ShippingMethods: {
					"ShippingMethods.id": "TrackingNumbers.shippingMethodId",
				},
			},
			{
				Units: {
					"Units.id": "ItemFulfillmentItemUnits.unitId",
				},
			},
			{
				Customers: {
					"Customers.id": "SalesOrders.customerId",
				},
			},
			{
				SalesOrderItems: {
					"SalesOrderItems.id":
						"ItemFulfillmentItems.salesOrderItemId",
				},
			},
			{
				InvoiceItems: {
					"InvoiceItems.salesOrderItemId": "SalesOrderItems.id",
				},
			},
			{
				Invoices: {
					"Invoices.id": "InvoiceItems.invoiceId",
				},
			},
			{
				PurchaseOrders: {
					"PurchaseOrders.id": "SalesOrders.purchaseOrderId",
				},
			},
			{
				Users: {
					"ItemFulfillments.fulfilledByUserId": "Users.id",
				},
			},
		],
		where: {
			and: [
				{
					"Units.uuid": {
						"=": unitUuid,
					},
				},
			],
		},
	};

	const resp = await togaApiRequest("GET", "/sales-orders", null, options);

	if (resp?.isSuccess) {
		return resp.data.salesOrders;
	} else {
		Sentry.captureMessage("getSalesOrderDetails", {
			level: "warning",
			tags: { errorType: "API" },
			extra: resp,
		});
		console.error("Failed to load sales order", resp);
		return null;
	}
}

// fetch all the data for that “Acquisition” modal starting at the receipt‐unit level
export async function getAcquisitionByUnit(unitUuid: string) {
	const options: ExtendedOptionsType = {
		page: 1,
		recordsPerPage: 1,
		sort: ["-ItemReceipts.dateItemReceipt"],
		fields: [
			"uuid",
			"ItemReceipts.dateItemReceipt",
			"Bills.dateBilled",
			"Bills.number",
			"Bills.status",
			"PurchaseOrders.number",
			"PurchaseOrders.dateOrder",
			"PurchaseOrderItems.cost",
			"Vendors.name",
			"TrackingNumbers.number",
		],
		ojoin: [
			{
				ItemReceiptItems: {
					"ItemReceiptItemUnits.itemReceiptItemId":
						"ItemReceiptItems.id",
				},
			},
			{
				ItemReceipts: {
					"ItemReceiptItems.itemReceiptId": "ItemReceipts.id",
				},
			},
			{
				PurchaseOrders: {
					"ItemReceipts.purchaseOrderId": "PurchaseOrders.id",
				},
			},
			{ Vendors: { "PurchaseOrders.vendorId": "Vendors.id" } },
			{ Units: { "ItemReceiptItemUnits.unitId": "Units.id" } },
			{ Bills: { "Bills.purchaseOrderId": "PurchaseOrders.id" } },
			{
				PurchaseOrderItems: {
					"ItemReceiptItems.purchaseOrderItemId":
						"PurchaseOrderItems.id",
				},
			},
			{
				TrackingNumbers: {
					"ItemReceiptItemUnits.trackingNumberId":
						"TrackingNumbers.id",
				},
			},
		],
		where: {
			and: [{ "Units.uuid": { "=": unitUuid } }],
		},
	};

	const resp = await togaApiRequest(
		"GET",
		"/item-receipt-item-units",
		null,
		options
	);

	if (resp?.isSuccess) {
		return resp.data.itemReceiptItemUnits;
	} else {
		Sentry.captureMessage("getAcquisitionDetailsByReceiptUnit", {
			level: "warning",
			tags: { errorType: "API" },
			extra: resp,
		});
		console.error("Failed to load acquisition details", resp);
		return null;
	}
}

// fetch everything needed for the “Receipt” modal
export async function getReceiptByUnit(unitUuid: string) {
	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"ItemReceipts.dateItemReceipt",
			"ItemReceipts.number",
			"TrackingNumbers.number",
			"TrackingNumbers.status",
			"ShippingCarriers.name",
			"ShippingMethods.name",
			"Users._name",
			"Addresses._singleLineFullAddress",
		],
		ojoin: [
			{
				ItemReceiptItems: {
					"ItemReceiptItemUnits.itemReceiptItemId":
						"ItemReceiptItems.id",
				},
			},
			{
				ItemReceipts: {
					"ItemReceiptItems.itemReceiptId": "ItemReceipts.id",
				},
			},
			{
				TrackingNumbers: {
					"ItemReceiptItemUnits.trackingNumberId":
						"TrackingNumbers.id",
				},
			},
			{
				Units: {
					"ItemReceiptItemUnits.unitId": "Units.id",
				},
			},
			{
				ShippingCarriers: {
					"TrackingNumbers.shippingCarrierId": "ShippingCarriers.id",
				},
			},
			{
				Users: {
					"ItemReceipts.receivedByUserId": "Users.id",
				},
			},
			{
				Locations: {
					"ItemReceipts.locationId": "Locations.id",
				},
			},
			{
				Locations_Addresses: {
					"Locations.primaryLocationAddressId":
						"Locations_Addresses.id",
				},
			},
			{
				Addresses: {
					"Locations_Addresses.addressId": "Addresses.id",
				},
			},
			{
				ShippingMethods: {
					"TrackingNumbers.shippingMethodId": "ShippingMethods.id",
				},
			},
		],
		where: {
			and: [{ "Units.uuid": { "=": unitUuid } }],
		},
	};

	const response = await togaApiRequest(
		"GET",
		"/item-receipt-item-units",
		null,
		options
	);

	if (response?.isSuccess) {
		return response.data.itemReceiptItemUnits;
	} else {
		Sentry.captureMessage("getReceiptUnitDetails", {
			level: "warning",
			tags: { errorType: "API" },
			extra: response,
		});
		console.error("Failed to load receipt-unit data", response);
		return [];
	}
}

// fetch all the data for that “Fulfillment” modal
export async function getFulfillmentByUnit(unitUuid: string) {
	const options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"ShippingCarriers.name",
			"TrackingNumbers.number",
			"TrackingNumbers.status",
			"ItemFulfillments.number",
			"ItemFulfillments.dateItemFulfillment",
			"Users._name",
			"Addresses._singleLineFullAddress",
			"ShippingMethods.name",
		],

		ojoin: [
			{
				ItemFulfillmentItems: {
					"ItemFulfillmentItemUnits.itemFulfillmentItemId":"ItemFulfillmentItems.id",
				},
			},
			{
				ItemFulfillments: {
					"ItemFulfillmentItems.itemFulfillmentId":"ItemFulfillments.id",
				},
			},
			{
				Units: {
					"ItemFulfillmentItemUnits.unitId": "Units.id"
				},
			},
			{
				TrackingNumbers: {
					"ItemFulfillmentItemUnits.trackingNumberId":"TrackingNumbers.id",
				},
			},
			{
				ShippingCarriers: {
					"TrackingNumbers.shippingCarrierId": "ShippingCarriers.id",
				},
			},
			{
				Users: {
					"Users.id": "ItemFulfillments.FulfilledByUserId"
				},
			},
			{
				Locations: {
					"ItemFulfillments.locationId": "Locations.id"
				}
			},
			{
				Locations_Addresses: {
					"Locations.primaryLocationAddressId":
						"Locations_Addresses.id",
				},
			},
			{
				Addresses: {
					"Locations_Addresses.addressId": "Addresses.id"
				}
			},
			{
				ShippingMethods: {
					"TrackingNumbers.shippingMethodId": "ShippingMethods.id",
				},
			},
		],
		where: {
			and: [{ "Units.uuid": { "=": unitUuid } }],
		},
	};

	const resp = await togaApiRequest(
		"GET",
		"/item-fulfillment-item-units",
		null,
		options
	);

	if (resp?.isSuccess) {
		return resp.data.itemFulfillmentItemUnits;
	} else {
		Sentry.captureMessage("getFulfillmentUnitDetails", {
			level: "warning",
			tags: { errorType: "API" },
			extra: resp,
		});
		console.error("Failed to load fulfillment data", resp);
		return [];
	}
}